var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnhideIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 5.33565L17.7205 4L15.6911 6.11879C14.2039 5.36625 12.5729 4.9444 10.857 4.9444C6.21483 4.9444 2.17166 7.98796 0 12.5C1.06752 14.7182 2.59158 16.5721 4.41256 17.8927L2.71451 19.6644L3.99403 21L6.01996 18.8852L8.36587 16.4372C8.36587 16.4372 8.36587 16.4372 8.36508 16.4372L19 5.33565ZM6.33342 12.5C6.33342 9.89165 8.3585 7.77773 10.8573 7.77773C11.7796 7.77773 12.6313 8.07213 13.3454 8.56735L12.0208 9.9497C11.6663 9.77373 11.2761 9.66665 10.8573 9.66665C9.3579 9.66665 8.14301 10.9348 8.14301 12.5C8.14301 12.9363 8.24559 13.3457 8.41417 13.7146L7.08991 15.0973C6.61624 14.3519 6.33342 13.4627 6.33342 12.5Z",
    fill: "#71277A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7538 8L16.0663 11.6242C16.0968 11.8437 16.1342 12.0611 16.1342 12.2878C16.1342 14.9502 13.9389 17.1078 11.23 17.1078C10.9981 17.1078 10.778 17.0711 10.5547 17.041L8 19.5526C9.03545 19.8398 10.1151 20 11.23 20C16.2625 20 20.6457 16.8943 23 12.2881C22.1582 10.6406 21.0527 9.18975 19.7538 8Z",
    fill: "#71277A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnhideIcon);
export default __webpack_public_path__ + "static/media/unhide_icon.a830ab7b2b22711a7285cf504e2926b6.svg";
export { ForwardRef as ReactComponent };